<template>
  <div class="news-item">
    <div class="news-item__teaser">
      <h4 class="text-white sectionSixh4 news-item__teaser-headline">
        {{ headline }}
      </h4>
      <p class="applicationtext">
        {{ teaser }}
        <button data-fancybox :data-src="`#${id}`" ref="javascript:;">
          {{ $t("read_more") }}
        </button>
      </p>
    </div>
    <div class="news-item__modal" :id="id">
      <p class="news-item__modal-date">
        {{ date }}
      </p>
      <h3 class="sectionSixh3">
        {{ headline }}
      </h3>
      <h4 class="sectionSixh4">
        {{ subheadline }}
      </h4>
      <hr />
      <p
        v-for="(paragraph, index) in paragraphs"
        :key="index"
        class="newstext"
        data-selectable="true"
        v-html="paragraph"
      ></p>
    </div>
    <hr v-if="!isLastElement" class="news-item__seperator" />
  </div>
</template>

<script>
export default {
  name: "NewsItem",
  props: {
    index: Number,
    headline: String,
    teaser: String,
    date: String,
    subheadline: String,
    paragraphs: Array,
    isLastElement: Boolean
  },
  computed: {
    id() {
      return `news-item-${this.index}`;
    }
  }
};
</script>

<style scoped>
.news-item__modal {
  display: none;
  max-width: 80%;
}

.news-item__teaser-headline {
  margin-bottom: 1rem;
}

.news-item__seperator {
  color: white;
  border: 3px solid white;
  border-radius: 5px;
  margin-top: 30px;
  margin-bottom: 30px;
}
.menu3 {
  display: inline;
}
.news-item__modal-date {
  font-size: 14px;
  font-weight: lighter;
  font-family: "Netto Regular", "Open Sans", sans-serif;
  color: black;
}
.newstext {
  font-family: "Netto Light", "Open Sans", sans-serif;
  color: black;
  font-size: 16px;
}
p {
  font-family: "Netto Bold";
  color: white;
  margin-bottom: 1rem;
}
button {
  text-decoration: none;
  color: black;
  background-color: transparent;
  border: none;
  padding-left: 0;
}
</style>
